import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Redirect /despre-noi → homepage + scroll la secțiunea despre
 */
const RedirectDespre = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/', { replace: true });
    setTimeout(() => {
      const element = document.getElementById('despre');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  }, [navigate]);

  return null;
};

export default RedirectDespre;
